// extracted by mini-css-extract-plugin
module.exports = {"titleWarning":"_1aefd33","itemWarning":"_c9017ac"};